<script>
import VueJsonPretty from 'vue-json-pretty';

/* COMPOSANTS */
import GaView from '@components/v2/layout/GaView';
import GaListView from '@components/v2/layout/GaListView.vue';
import AkDatatablePagination from '@components/v2/general/AkDatatablePagination.vue';
import AkSidebar from '@components/v2/general/AkSidebar.vue';
import AkInputTextArea from '@components/v2/input/AkInputTextArea.vue';

/* MIXINS */
import loaderMixin from '@mixins/loaderMixin';
import messageMixin from '@mixins/messageMixin';
import utilsMixin from '@mixins/utilsMixin';
import otaMessageTypeConst from '@mixins/const/otaMessageTypeConst';
import languageConst from '@mixins/const/languageConst';

/* SERVICES */
import otaMessageService from '@services/otaMessageService';

export default {
  components: {
    GaView,
    GaListView,
    AkDatatablePagination,
    AkSidebar,
    AkInputTextArea,
    VueJsonPretty,
  },
  mixins: [loaderMixin, messageMixin, utilsMixin, otaMessageTypeConst, languageConst],
  head() {
    return {
      title: 'settings.ota_message',
    };
  },
  data() {
    return {
      list: [],
      filter: {},
      item: {},
      loading: true,
      sidebarVisible: false,
      itemSelected: {},
    };
  },
  computed: {},
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.loading = true;
      otaMessageService
        .otaMessages(this.filter)
        .then((data) => {
          this.list = data;
        })
        .catch((error) => {
          const message = this.msgForErr(this.$t, error);
          this.addError(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // SIDEBAR

    rowClick(event) {
      this.itemSelected = event.data;
      this.sidebarVisible = true;
    },

    hideSidebar() {
      this.itemSelected = {};
      this.sidebarVisible = false;
    },

    // DISPLAY

    // TODO: Améliorer en passant par une constante ou autre
    getDisplayDeliveryWindow(value) {
      if (value == null) return 'Aucune valeur';
      const absValue = Math.abs(value);
      let display = '';

      // Moins de 24h ou 1440 minutes
      if (absValue < 1440) {
        display += absValue / 60;
        display += ' heure(s)';
      } else {
        display += absValue / 1440;
        display += ' jour(s)';
      }

      if (value < 0) {
        display += ' avant';
      } else {
        display += ' après';
      }
      return display;
    },
  },
};
</script>

<template>
  <GaView>
    <template #action>
      <!--      <div class="flex justify-end">-->
      <!--        <span @click="toggleCreateSidebar" class="btn-primary xs">Ajouter un compte</span>-->
      <!--      </div>-->
    </template>

    <template #content>
      <GaListView>
        <template #content>
          <AkDatatablePagination :loading="loading" :value="list" :lazy="false" @row-click="rowClick($event)">
            <template #empty>{{ $t('ota_message.empty') }}</template>
            <Column header="Plateforme" style="width: 140px">
              <template #body="slotProps">
                {{ slotProps.data.platform }}
              </template>
            </Column>
            <Column header="Type" style="width: 140px">
              <template #body="slotProps">
                {{ displayForOtaMessageTypeConst(slotProps.data.type) }}
              </template>
            </Column>
            <Column header="Langue" style="width: 140px">
              <template #body="slotProps">
                {{ displayForLanguageConst(slotProps.data.locale.toLowerCase()) }}
              </template>
            </Column>
            <Column header="Titre" style="min-width: 200px">
              <template #body="slotProps">
                {{ slotProps.data.title }}
              </template>
            </Column>
            <Column header="Fenêtre de livraison" style="min-width: 200px">
              <template #body="slotProps">
                {{ getDisplayDeliveryWindow(slotProps.data.deliveryWindow) }}
              </template>
            </Column>
            <Column header="Heure de livraison" style="min-width: 200px">
              <template #body="slotProps">
                {{ slotProps.data.deliveryTime }}
              </template>
            </Column>
            <Column body-style="text-align: right; overflow: visible" style="width: 120px">
              <template #body="slotProps"></template>
            </Column>
          </AkDatatablePagination>
        </template>
      </GaListView>
    </template>

    <template #extra>
      <AkSidebar
        ref="sidebarDetails"
        :baseZIndex="9998"
        v-model:visible="sidebarVisible"
        block-scroll
        position="right"
        :dismissable="true">
        <template #container>
          <div class="p-sidebar-header">
            <div class="p-sidebar-header-content">Détail du modèle n°{{ itemSelected.id }}</div>
            <button class="p-sidebar-close p-sidebar-icon p-link" type="button" @click="hideSidebar">
              <span
                class="p-sidebar-close-icon ga-icon ga-close_circle text-4xl text-grey-400 md:hover:text-grey-900 md:hover:bg-transparent" />
            </button>
          </div>

          <div class="p-sidebar-content">
            <perfect-scrollbar class="h-full flex flex-col gap-4 p-3">
              <div class="flex gap-2">
                <div class="flex flex-col gap-2 flex-1">
                  <span class="font-inter font-semibold text-grey-900 text-base">Plateforme</span>
                  <span class="font-inter font-medium text-grey-400 text-md">{{ itemSelected.platform }}</span>
                </div>
                <div class="flex flex-col gap-2 flex-1">
                  <span class="font-inter font-semibold text-grey-900 text-base">Langue</span>
                  <span class="font-inter font-medium text-grey-400 text-md">
                    {{ displayForLanguageConst(itemSelected.locale?.toLowerCase()) }}
                  </span>
                </div>
                <div class="flex flex-col gap-2">
                  <span class="font-inter font-semibold text-grey-900 text-base">Type</span>
                  <span class="font-inter font-medium text-grey-400 text-md">
                    {{ displayForOtaMessageTypeConst(itemSelected.type) }}
                  </span>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <span class="font-inter font-semibold text-grey-900 text-base">Titre</span>
                <span class="font-inter font-medium text-grey-400 text-md">{{ itemSelected.title }}</span>
              </div>
              <div class="flex gap-2">
                <div class="flex flex-col gap-2 flex-1">
                  <span class="font-inter font-semibold text-grey-900 text-base">Fenêtre de livraison</span>
                  <span class="font-inter font-medium text-grey-400 text-md">
                    {{ getDisplayDeliveryWindow(itemSelected.deliveryWindow) }}
                  </span>
                </div>
                <div class="flex flex-col gap-2 flex-1">
                  <span class="font-inter font-semibold text-grey-900 text-base">Heure de livraison</span>
                  <span class="font-inter font-medium text-grey-400 text-md">{{ itemSelected.deliveryTime }}</span>
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <span class="font-inter font-semibold text-grey-900 text-base">Filtres</span>
                <div class="bg-[#262626] p-2 rounded-xl text-white">
                  <vue-json-pretty
                    :data="this.itemSelected.filters"
                    :highlight-selected-node="false"
                    :show-length="true"
                    :show-select-controller="false"
                    :showLine="false"
                    theme="dark"
                    :deep="2"
                    :collapsed-on-click-brackets="true" />
                </div>
              </div>
              <div class="flex flex-col gap-2">
                <AkInputTextArea v-model="itemSelected.message" label="Message" :rows="20" disabled />
              </div>
            </perfect-scrollbar>
          </div>
        </template>
      </AkSidebar>
    </template>
  </GaView>
</template>
<style lang="scss" scoped>
@import 'vue-json-pretty/lib/styles.css';
</style>
